import { api } from '../helpers';

const authenticate = async (username: string, password: string, rememberMe: boolean, captchaToken: string) => {
    const body = { username, password, rememberMe, captchaToken };
    return await api.post('/authenticate/link-pay', body).then((response) => response.data);
};

const authenticateVerify = async (username: string, password: string, authyCode: string, captchaToken: string) => {
    const body = { username, password, authyCode, captchaToken };
    return await api.post('/authenticate/link-pay/google-authy-verify', body).then((response) => response.data);
};

const finishPasswordReset = (key: string, newPassword: string) =>
    api.post('/account/reset-password/finish', { key, newPassword });

export const publicService = {
    authenticate,
    authenticateVerify,
    finishPasswordReset,
};
